// note: only used for track -- see footer_tracking_internal.jsp for identity tracking

// From scripts loaded in header_tracking_internal.tag
/* global heap ga optimizely */

(function () {
    function DCAnalytics() {}

    DCAnalytics.prototype.track = function (trackName, trackParams) {
        if (typeof heap !== 'undefined') {
            if (trackName.length > 255) {
                trackName = trackName.substring(0, 254);
            }
            heap.track(trackName, trackParams);
        }
    };

    DCAnalytics.prototype.trackOptX = function (trackName, trackRevenue) {
        // ensures the optimizely object is defined globally using
        window.optimizely = window.optimizely || [];

        // Use revenue cautiously -- revenue is cumulative so make sure it can't be triggered multiple times by page reload
        trackRevenue = (trackRevenue) ? parseFloat(trackRevenue) : 0.00;
        const trackRevenueInCents = Math.round(trackRevenue * 100.00);

        // sends a tracking call to Optimizely for the given event name.
        window.optimizely.push({
            type: 'event',
            eventName: trackName,
            tags: {
                revenue: trackRevenueInCents, // Optional in cents as integer (500 == $5.00)
                value: trackRevenue, // Optional as float
            },
        });
    };

    DCAnalytics.prototype.addUserProperties = function (trackName, trackProperty) {
        if (typeof heap !== 'undefined') {
            const jsonVariable = {};
            jsonVariable[trackName] = trackProperty;
            heap.addUserProperties(jsonVariable);
        }
    };

    /*
     * Rewrite old google analytics event tracking
     * https://developers.google.com/analytics/devguides/collection/gajs/eventTrackerGuide
     *
     * To google analytics universal event tracking
     * https://developers.google.com/analytics/devguides/collection/analyticsjs/events
     */
    DCAnalytics.prototype.trackEventGANonInteraction = function (dataArray, trackerName) {
        let sendType = 'send';
        if (trackerName) {
            sendType = trackerName + '.send';
        }

        if (typeof ga !== 'undefined') {
            // quick fix for "_-_" back to " - "
            if (dataArray[0] != null && dataArray[0].indexOf('_-_') > -1) {
                dataArray[0] = dataArray[0].replace(/_/g, ' ');
            }
            switch (dataArray.length) {
            case 2:
                ga(sendType, 'event', dataArray[0], dataArray[1], { nonInteraction: 1 });
                break;
            case 3:
                ga(sendType, 'event', dataArray[0], dataArray[1], dataArray[2], { nonInteraction: 1 });
                break;
            case 4:
                ga(sendType, 'event', dataArray[0], dataArray[1], dataArray[2], dataArray[3], { nonInteraction: 1 });
                break;
            }
        }
    };

    DCAnalytics.prototype.trackEventGA = function (dataArray, trackerName) {
        let sendType = 'send';
        if (trackerName) {
            sendType = trackerName + '.send';
        }
        if (typeof ga !== 'undefined') {
            switch (dataArray.length) {
            case 2:
                ga(sendType, 'event', dataArray[0], dataArray[1]);
                break;
            case 3:
                ga(sendType, 'event', dataArray[0], dataArray[1], dataArray[2]);
                break;
            case 4:
                ga(sendType, 'event', dataArray[0], dataArray[1], dataArray[2], dataArray[3]);
                break;
            }
        }
    };

    DCAnalytics.prototype.createHelpCenterTracker = function () {
        if (typeof ga !== 'undefined') {
            ga('create', 'UA-2016540-7', 'auto', 'helpcenter');
            ga('helpcenter.send', 'pageview');
        }
    };

    DCAnalytics.prototype.trackHelpCenter = function (dataArray) {
        this.trackEventGA(dataArray, 'helpcenter');
    };

    function isGivingCartFlow() {
        const cartPathNames = ['givingCart.html', 'recurring_donation_signup', 'cartThankYou', 'cartDonationMessage'];
        for (let i = 0; i < cartPathNames.length; i++) {
            if (window.location.pathname.indexOf(cartPathNames[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    DCAnalytics.prototype.trackIdentityGA = function () {
        // track identity and other custom dimensions in google analytics,
        // but don't change during cart flow
        if (!isGivingCartFlow()) {
            if (typeof ga !== 'undefined') {
                if (typeof userId !== 'undefined' && userId) {
                    ga('set', 'dimension2', userId);
                }
                if (typeof userType !== 'undefined' && userType) {
                    ga('set', 'dimension1', window.getTopDonorOrUserType());
                    window.createCookie('v', userType, 365);
                } else if (readCookie('v') != null) {
                    ga('set', 'dimension1', readCookie('v'));
                } else {
                    ga('set', 'dimension1', 'unknown');
                }
                if (readCookie('__utma') != null) {
                    const visitorId = readCookie('__utma').split('.');
                    if (visitorId.length > 1) {
                        ga('set', 'dimension3', visitorId[1]);
                    }
                }
            }
        }
    };

    DCAnalytics.prototype.trackPageViewGA = function (pageView) {
        if (typeof ga !== 'undefined') {
            if (typeof pageView === 'string' && pageView.length > 0) {
                ga('send', 'pageview', pageView);
            } else {
                ga('send', 'pageview');
            }
        }
    };

    DCAnalytics.prototype.trackPageViewForCart = function (pageView, additionalParamsForHeap) {
        this.trackPageViewGA(pageView);
        window.addEventListener('generalLoaded', function trackPageViewForCartInit() {
            if (pageView.indexOf('?') > -1) {
                const pageViewURI = new Uri(pageView);
                const name = pageViewURI.path();
                const params = window.getQueryStringParamsBasedOnSplit(pageViewURI.query());
                if (additionalParamsForHeap) {
                    for (const p in additionalParamsForHeap) {
                        params[p] = additionalParamsForHeap[p];
                    }
                }
                dcAnalytics.track(name, params);
            } else {
                dcAnalytics.track(pageView);
            }
        });
    };

    // tracking for both heap and optimizely
    DCAnalytics.prototype.trackDonationRevenue = function (cartDetails) {
        const revenue = cartDetails.revenue;
        const revenueInCents = Math.round(revenue * 100.00);
        // heap
        dcAnalytics.track('Donation', {
            'Giving Cart Id': cartDetails.givingCartId,
            revenue,
            'Giving Cart Price': cartDetails.totalPrice,
        });

        // optimizelyX
        window.optimizely = window.optimizely || [];
        window.optimizely.push({
            type: 'event',
            eventName: 'Donation',
            tags: {
                revenue: revenueInCents,
            },
        });
    };

    DCAnalytics.prototype.getProjectIdFromShareLink = function (shareLink) {
        const regex = /\/project\/[^/]+\/([0-9]+).*/;
        const result = regex.exec(shareLink);
        if (result && result.length && result.length > 1) {
            return result[1];
        }

        // In case the shareLink performed a url escape on the share url
        const regexForUrlEscapedShareUrl = /%2Fproject%2F(?:(?!%2F).)+%2F((?!%2F).+)%2F/;
        const altResult = regexForUrlEscapedShareUrl.exec(shareLink);
        if (altResult && altResult.length && altResult.length > 1) {
            return altResult[1];
        }

        // If the URL was not properly set, then try to find it via shareData - this is a hack because the track functions are called in various places
        // and I keep missing one or two
        if (window.shareData && shareData.emailShareURL && shareData.emailShareURL.length) {
            const projectId = this.getProjectIdFromUrlParams(shareData.emailShareURL);
            if (projectId) {
                return projectId;
            }
        }
        return null;
    };

    DCAnalytics.prototype.getProjectIdFromUrlParams = function (shareLink) {
        let projectId = window.getURLParam(shareLink, 'proposalId');
        if (!projectId) {
            projectId = window.getURLParam(shareLink, 'projectId');
        }
        return projectId;
    };

    DCAnalytics.prototype.getTeacherIdFromUrlParams = function (shareLink) {
        return window.getURLParam(shareLink, 'teacherId');
    };

    DCAnalytics.prototype.trackShareToolClick = function (pageName, targetUrl, channel, isEssentialsListShare) {
        if (isEssentialsListShare) {
            const teacherId = this.getTeacherIdFromUrlParams(targetUrl);
            const currentUrl = window.location.href;
            // console.log('essentials list share', pageName, targetUrl, channel, teacherId, isEssentialsListShare, currentUrl);
            dcAnalytics.track('ShareToolClick', {
                currentUrl,
                pageName,
                targetUrl,
                channel,
                teacherId,
                isEssentialsListShare,
            });
        } else {
            let projectId = this.getProjectIdFromShareLink(targetUrl);
            if (!projectId) {
                projectId = this.getProjectIdFromUrlParams(targetUrl);
            }
            // If the URL was not properly set, then try to find it via shareData - this is a hack because the track functions are called in various places
            // and I keep missing one or two
            if (!projectId && typeof shareData !== 'undefined' && shareData && shareData.emailShareURL && shareData.emailShareURL.length && shareData.emailShareURL.length > 0) {
                // console.log('FALLBACK projectId check called');
                projectId = this.getProjectIdFromUrlParams(shareData.emailShareURL);
                // console.log('FALLBACK projectId check returned ' + projectId);
            }
            const currentUrl = window.location.href;
            // console.log('inside trackShareToolClick', pageName, targetUrl, channel, projectId, currentUrl);
            dcAnalytics.track('ShareToolClick', {
                currentUrl,
                pageName,
                targetUrl,
                channel,
                projectId,
            });
        }

        window.optimizely = window.optimizely || [];
        window.optimizely.push({
            type: 'event',
            eventName: 'ShareToolClick',
            tags: {
                pageName,
                targetUrl,
                channel,
            },
        });
    };

    // Called from many JS and at least one JSP
    window.dcAnalytics = new DCAnalytics();
    window.dispatchEvent(new CustomEvent('dcAnalytics'));

    $(document).bind('optimizelyLoaded', function () {
        // first track Optimizely X
        const optData = optimizely.get('data');
        const optState = optimizely.get('state');
        const optExperimentStates = optState.getExperimentStates({ isActive: true });
        const optExperimentIDs = optState.getActiveExperimentIds();
        if (typeof optExperimentIDs !== 'undefined' && optExperimentIDs.length > 0) {
            for (let i = 0; i < optExperimentIDs.length; i++) {
                const experimentID = optExperimentIDs[i];
                const experiment = optExperimentStates[experimentID];
                const experimentName = experiment.experimentName;
                const variationID = experiment.variation.id;
                const variationName = experiment.variation.name;
                let variationIndex = -1;
                const variations = optData.experiments[experimentID].variations;
                for (let j = 0; j < variations.length; j++) {
                    if (variations[j].id == variationID) {
                        variationIndex = j;
                        break;
                    }
                }
                let heapName = 'optimizely_x' + experimentID + '_' + variationIndex + '_' + experimentName.split(' ').join('-');
                if (heapName.length > 1024) heapName = heapName.substring(0, 1023);
                const variationNameShort = (variationName.length > 1024) ? variationName.substring(0, 1023) : variationName;
                heap.track(heapName, {
                    experimentName,
                    variationName: variationNameShort,
                    variationID,
                });

                if (typeof FS !== 'undefined') {
                    // From FullStory script
                    /* global FS */
                    const fsName = 'optimizely' + experimentID + '_str';
                    const fsVariation = 'optimizelyVar' + variationID;
                    const jsonVariable = {};
                    jsonVariable[fsName] = fsVariation;
                    FS.setUserVars(jsonVariable);
                }

                // temporarily record optimizely as both event and user property
                let userPropertyKey = 'optimizely_x' + experimentID + experimentName;
                if (userPropertyKey.length > 1024) userPropertyKey = userPropertyKey.substring(0, 1023);
                const userPropertyValue = variationName;
                const props = {};
                props[userPropertyKey] = userPropertyValue;
                heap.addUserProperties(props);
            }
        }
    });
})();
